import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginBottom: '1rem',
  },
  form: {
    padding: '1em',
  },
  status: {
    marginBottom: '2rem',
  },
  submitButton: {
    alignSelf: 'end',
    // width: '120px',
  },
  applyCouponCodeButton: {
    marginLeft: '5px',
    // width: '100px',
  },
  toolbar: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
  },
  totalContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'end',
    marginRight: '.5rem',
  },
  totalValue: {
    fontWeight: 'bold',
    marginLeft: '.5rem',
  },
}));

export {
  useStyles,
};
